<template>
  <div>
    <b-button
      :variant="variant"
      :size="size"
      :disabled="isButtonDisabled"
      :class="buttonClass"
      @click="payInvoice"
    >
      <b-spinner
        v-if="isLoading"
        variant="light"
        small
      />
      Bayar
    </b-button>
    <PayInvoiceProcess
      ref="pay-invoice-process"
      :invoice-id="invoiceId"
      :ref-id="refId"
      :is-from-tagihan="fromTagihan"
      :on-close="handleClose"
    />
  </div>
</template>

<script>
/**
 * Component untuk menampilkan tombol bayar tagihan
 *
 * Component ini menampilkan tombol bayar tagihan yang terdiri dari tombol bayar tagihan,
 * modal konfirmasi pembayaran, dan modal pembayaran untuk memproses pembayaran tagihan.
 *
 * @props {String|Number} invoiceId - ID tagihan untuk memproses pembayaran tagihan
 * @props {String|Number} refId - Ref ID tagihan untuk redirect ke halaman Detail Riwayat Saldo - Rincian Pemayaran Low Moving Stock
 * @props {Boolean} fromTagihan - Apakah dari halaman Tagihan atau bukan(halaman Detail Tagihan)
 * @props {String} variant - Variant tombol
 * @props {Boolean} disabled - Apakah tombol disabled
 * @props {String} size - Size tombol
 * @props {String} buttonClass - Class tombol
 * @props {Function} onClose - Fungsi yang akan dipanggil ketika modal konfirmasi pembayaran tagihan ditutup
 */
import PayInvoiceProcess, { PAYMENT_STATUS } from './modal/PayInvoiceProcess.vue'

export default {
  name: 'ButtonBayarTagihan',
  components: {
    PayInvoiceProcess,
  },
  props: {
    invoiceId: {
      type: [String, Number],
      required: true,
    },
    refId: {
      type: [String, Number],
      required: true,
    },
    fromTagihan: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'primary',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: '',
    },
    buttonClass: {
      type: String,
      default: 'btn btn-primary btn-sm flex items-center gap-4 justify-center',
    },
  },
  data() {
    return {
      isLoading: false,
      confirmPopup: null,
      isDisabled: false,
    }
  },
  computed: {
    isButtonDisabled() {
      return this.isLoading || this.disabled || this.isDisabled
    },
  },
  methods: {
    payInvoice() {
      this.$refs['pay-invoice-process'].show()
      this.isLoading = true
    },
    handleClose({ status }) {
      this.$emit('on-close', {
        isSuccess: status === PAYMENT_STATUS.SUCCESS,
      })
      this.isLoading = false
    },
  },
}
</script>
